import { TimeIntervalTypeEnum } from '../../Enum/TimeIntervalTypeEnum';
import BaseEntity from '../BaseEntity.model';

export default interface ISchedulePlan extends BaseEntity {
    Provider: ProviderPreview;
    TimeIntervalIndays: number;
    TimeIntervalType: TimeIntervalTypeEnum;
    SelectedForDelete: boolean;
    CreatedAt: string;
    UpdatedAt: string;
}

export class ProviderPreview {
    Id: string;
    Name: string;
    Role: string;
}

export class SchedulePlan implements ISchedulePlan {
    Id: string | null;
    Provider: ProviderPreview;
    TimeIntervalIndays: number;
    TimeIntervalType: TimeIntervalTypeEnum;
    SelectedForDelete: boolean;
    IsSelected: boolean;
    CreatedAt: string;
    UpdatedAt: string;

    constructor() {
        this.Id = null;
        this.SelectedForDelete = false;
        this.IsSelected = false;
        this.CreatedAt = '';
        this.UpdatedAt = '';
    }
}
